import { fontStyles } from '@/styles/typography';

import { classNames } from '@/utils/classnames';

import { TextSkeleton } from '../../Skeleton';
import { TableColumn } from '../config';
import { getDataCellClass, getHeaderCellClass } from '../utils';

interface TableSkeletonProps {
  numRows: number;
  columns: TableColumn[];
}

export function TableSkeleton({ columns, numRows }: TableSkeletonProps) {
  return (
    <table className="w-full tablet:table-fixed" aria-busy="true">
      <thead
        className={classNames(
          'border-y border-y-special-border-divider border-solid h-[38px]',
          fontStyles({ variant: 'LABEL_SM', class: 'text-token-gray-800' }),
        )}
      >
        <tr className="text-left">
          {columns.map((column) => (
            <th
              key={column.key}
              data-cell={column.key}
              data-is-skeleton="true"
              className={getHeaderCellClass(String(column.key), { isSkeleton: true })}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: numRows }).map((_, index) => (
          <tr
            className={classNames(
              fontStyles({ variant: 'BODY_MD' }),
              'cursor-pointer border-b border-b-special-border-divider h-12 transition-colors duration-150 group/row',
              'hover:bg-token-gray-200 active:bg-token-gray-200',
              'aria-selected:bg-[rgba(89,50,243,0.08)] aria-selected:hover:bg-[rgba(89,50,243,0.08)]',
              'last:border-b-0 last:[&>td:first-child]:rounded-bl-[20px] last:[&>td:last-child]:rounded-br-[20px] last:rounded-b-[20px]',
            )}
            key={index}
          >
            {columns.map((column, index) => (
              <td
                key={index}
                data-cell={column.key}
                data-is-skeleton="true"
                className={getDataCellClass(String(column.key), { isSkeleton: true })}
              >
                <TextSkeleton width="100%" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
